export default __webpack_public_path__ + "BarBlue.png";